import React from 'react';
import Footer from '../components/Footer';
import useMetaTags from '../common-functions/useMetaTags';
import { BookingsExperience } from '../bookings/BookingsExperience';
import HeaderSection from '../sections/HeaderSection';
import HeadImg from '../assets/Images/common/career.jpg';

const Bookings: React.FC = () => {
  useMetaTags(
    'Book Time With Binary Republik | Binary Republik',
    'Schedule discovery calls, workshops, and follow-up sessions with the Binary Republik team.',
    '',
  );

  return (
    <>
      <HeaderSection pageName="Book a Consultation" imageUrl={HeadImg} alt="Book a consultation with Binary Republik" />
      <BookingsExperience />
      <Footer hasWorkItem={false} />
    </>
  );
};

export default Bookings;
